export const productDetailsVariantProps = () => ({
  availableSizes: {
    type: Array,
    required: true
  },
  defaultSize: {
    type: String,
    required: true
  },
  defaultColor: {
    type: String,
    required: true
  },
  availableColors: {
    type: Array,
    required: true
  },
  isNational: {
    type: Boolean,
    required: true
  }
})

export const productDetailsVariantEmits = () => ([
  "variantChanged"
])

export const useProductDetailsVariant = (props, context) => {
  const selectedColor = ref(props.defaultColor)
  const selectedSize = ref(props.defaultSize)
  const sizesGuideLink = "/infos-et-services/aide/guide-des-tailles"

  const variantChanged = () => {
    context.emit("variantChanged", selectedColor.value, selectedSize.value);
  }

  return {
    selectedColor,
    selectedSize,
    sizesGuideLink,
    variantChanged
  }
}